<template>
    <div>
        <div class="modal" v-bind:style="(showConfirmDeleteModal) ? 'display: unset;':'display: none;'" >
            <transition name="modal" >
            <div class="modal-mask" >
            <div class="modal-wrapper" >
                <div class="modal-dialog modal-dialog-scrollable mv-md-100 w-md-75" >
                    <div class="modal-content" >
                        <div class="modal-header" >
                            <h5 class="modal-title">Potwierdź chęć usunięcia turnieju</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-on:click="showConfirmDeleteModal = false;" ></button>
                        </div>
                        <div class="modal-body">
                            Czy na pewno chcesz usunać turniej "{{ deleteTournametName }}"?
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary w-25" data-bs-dismiss="modal" v-on:click="showConfirmDeleteModal = false;" >Anuluj</button>
                            <button type="button" class="btn btn-danger w-25" data-bs-dismiss="modal" v-on:click="showConfirmDeleteModal = false; onDeleteTournametModalClick();" >OK</button>
                        </div>
                    </div>
                </div>

            </div>
            </div>
            </transition>
        </div>

        <svg width="0" height="0"class="d-none" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <symbol v-bind:id="'deleteItem' + _uid" viewBox="0 0 16 16" class="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                </symbol>
                <symbol v-bind:id="'editItem' + _uid" class="bi bi-pen" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M13.498.795l.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001zm-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708l-1.585-1.585z" />
                </symbol>
                <symbol v-bind:id="'saveItem' + _uid" class="bi bi-floppy" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" >
                    <path d="M11 2H9v3h2z"/>
                    <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z"/>
                </symbol>
                <symbol v-bind:id="'cancelEditItem' + _uid" class="bi bi-x-circle" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
                </symbol>
            </defs>
        </svg>

        <vue-good-wizard ref="wizardTournamentCreator" previousStepLabel="Wstecz" nextStepLabel="Dalej" finalStepLabel="Zakończ" v-bind:steps="wizardSteps" v-bind:onNext="nextClicked" v-bind:onBack="backClicked">
            <div slot="page1" >
                <h4>Krok 1</h4>
                <p>Zbieranie podstawowych informacji</p>
                <hr>
                <div class="row" >
                    <div class="col-6 col-md-5 col-xl-3" >
                        <div class="form-check">
                            <input class="form-check-input" v-model.number="currentEditMode" v-bind:value="0" type="radio" v-on:change="currentTournametIndex = -1; onSelectTournametChange();" name="currentEditMode" :id="'currentEditMode0' + _uid" checked>
                            <label class="form-check-label" :for="'currentEditMode0' + _uid">
                                Stwórz nowy turniej
                            </label>
                        </div>
                        <div class="form-check mt-2">
                            <input class="form-check-input" v-bind:disabled="(allTournamentsList.length === 0)" v-model.number="currentEditMode" v-bind:value="1" type="radio" v-on:change="currentTournametIndex = 0; onSelectTournametChange();" name="currentEditMode" :id="'currentEditMode1' + _uid" >
                            <label class="form-check-label" :for="'currentEditMode1' + _uid">
                                Edytuj istniejący turniej
                            </label>
                        </div>
                        <div class="form-check mt-2">
                            <input class="form-check-input" v-bind:disabled="(allTournamentsList.length === 0)" v-model.number="currentEditMode" v-bind:value="3" type="radio" v-on:change="currentTournametIndex = 0; onSelectTournametChange();" name="currentEditMode" :id="'currentEditMode3' + _uid" >
                            <label class="form-check-label" :for="'currentEditMode3' + _uid">
                                Usuń turniej
                            </label>
                        </div>
                    </div>
                    <div class="col-6 col-md-5 col-xl-3" >

                        <div v-bind:class="(currentEditMode === 3) ? 'd-flex' : 'd-none'" class="flex-column" >
                            <label class="form-label" :for="'selectTournametDelete' + _uid">
                                    Usuń turniej
                            </label>
                            <select v-model.number="currentTournametIndex" :id="'selectTournametDelete' + _uid" v-on:change="onSelectTournametChange" class="form-select mt-2" >
                                <option v-for="(tournament, index) in allTournamentsList" :key="index" v-bind:value="index" >
                                    {{ tournament.name }}
                                </option>
                            </select>
                            <button v-bind:id="'btnDeleteTournamet' + _uid" v-bind:disabled="((currentTournamet === null) || (currentTournamet.id < 0))"  type="button" class="btn btn-danger mt-4 align-self-center d-block d-md-none" style="color: #FFFFFF;" v-on:click="onDeleteTournametClick">
                                <svg width="1.5em" height="1.5em" >
                                    <use :xlink:href="'#deleteItem' + _uid"></use>
                                </svg>
                            </button>
                        </div>

                        <div v-show="currentEditMode === 1" >
                            <label class="form-label" :for="'selectTournamet' + _uid">
                                    Edytuj istniejący turniej
                            </label>
                            <select v-model.number="currentTournametIndex" :id="'selectTournamet' + _uid" v-on:change="onSelectTournametChange" class="form-select mt-2" >
                                <option v-for="(tournament, index) in allTournamentsList" :key="index" v-bind:value="index" >
                                    {{ tournament.name }}
                                </option>
                            </select>
                        </div>

                        <div v-show="currentEditMode === 0" >
                            <label :for="'tournametName' + _uid" class="form-label">Wpisz nazwę dla nowego turnieju</label>
                            <input type="text" v-model.trim="currentTournamet.name" class="form-control mt-2" :id="'tournametName' + _uid" placeholder="Wpisz nazwę turnieju" >
                        </div>
                    </div>
                    <div class="col col-md-2 d-none d-md-block"  >

                        <div v-show="currentEditMode === 3" class="h-100">
                            <div class="d-flex h-100 align-items-end pb-1">

                                    <button v-bind:id="'btnDeleteTournamet' + _uid" v-bind:disabled="((currentTournamet === null) || (currentTournamet.id < 0))"  type="button" class="btn btn-danger mb-2" style="color: #FFFFFF;" v-on:click="onDeleteTournametClick">
                                        <svg width="1.5em" height="1.5em" >
                                            <use :xlink:href="'#deleteItem' + _uid"></use>
                                        </svg>
                                    </button>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3" >
                    <div class="col-8 col-md-4 col-xl-3" >
                        <label :for="'numberPointsSendingResults' + _uid" class="form-label">Liczba punktów przesyłania wyników</label>
                        <input type="text" v-model.number="currentTournamet.numberPointsSendingResults" class="form-control w80p" :id="'numberPointsSendingResults' + _uid" placeholder="1" >
                    </div>
                    <div class="col-4 col-md-3 col-xl-1 ps-0 ps-md-3" >
                        <label :for="'roundsCount' + _uid" class="form-label">Liczba gier</label>
                        <input type="text" v-model.number="currentTournamet.roundsCount" class="form-control w80p" :id="'roundsCount' + _uid" placeholder="1" >
                    </div>
                    <div class="col-12 col-md-5 col-xl-3" >
                        <div class="form-switch mt-2 mt-md-0">
                            <label class="form-check-label" :for="'confirmIncomingResults' + _uid" >Włącz zatwierdzanie przychodzących wyników</label>
                            <input class="form-check-input checbox-confirm form-switch-fix" v-model="currentTournamet.confirmIncomingResults"  type="checkbox" :id="'confirmIncomingResults' + _uid">
                        </div>
                    </div>
                </div>
            </div>
            <div slot="page2" >
                <h4>Krok 2</h4>
                <p>Zapisy do turnieju</p>
                <hr>
                <div class="row justify-content-center" >
                    <div class="col-12 col-xl-8 px-4" >

                        <p class="w-100 mx-auto" >Zaznaczono: {{ selectedCounter }}</p> 

                        <div class="row table-list-header" id="currentTournametListHeader" >
                            <div class="col-2 col-lg-1 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" >
                                <input class="form-check-input mt-0" type="checkbox" v-bind:true-value="true" v-bind:false-value="false"
                                    v-model="currentTournametListSelectAllState" v-on:change="onCurrentTournametListSelectAllChange()" >
                            </div>
                            <div class="col-10 col-md-6 col-lg-4 d-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" >Nazwisko i Imię</div>
                            <div class="col col-md-4 col-lg-3 d-none d-md-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" >Skrócona nazwa</div>
                            <div class="col col-lg-2 d-none d-lg-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" >HDCP 1r</div>
                            <div class="col col-lg-2 d-none d-lg-flex align-items-center justify-content-center table-item table-header-item text-center text-nowrap" >Bonus</div>
                        </div>

                        <div class="row" >
                            <div class="col table-scroll-y" id="currentTournametListScroll" >
                                <div class="row" v-for="(player, index) in currentTournametPlayersList" :key="index" >
                                    <div class="col-2 col-lg-1 d-flex align-items-center justify-content-center table-item text-center text-nowrap" >
                                        <input class="form-check-input mt-0" type="checkbox" v-bind:true-value="true" v-bind:false-value="false"
                                            v-bind:disabled="player.disabled" v-model="player.isPresent" >
                                    </div>
                                    <div class="col-10 col-md-6 col-lg-4 d-flex align-items-center justify-content-center table-item text-center text-nowrap" >{{ player.name }}</div>
                                    <div class="col col-md-4 col-lg-3 d-none d-md-flex align-items-center justify-content-center table-item text-center text-nowrap" >{{ player.shortname }}</div>
                                    <div class="col col-lg-2 d-none d-lg-flex align-items-center justify-content-center table-item text-center text-nowrap" >{{ player.hdcp1r }}</div>
                                    <div class="col col-lg-2 d-none d-lg-flex align-items-center justify-content-center table-item text-center text-nowrap" >{{ player.bonus }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>          
            <div slot="page3" >
                <h4>Krok 3</h4>
                <p>Przydzielanie zawodników do punktów przesyłania wyników</p>
                <hr>
                <div class="row" >
                    <div class="col col-md-9" >
                        <div class="row" >
                            <template v-for="(point, index) in currentTournamet.points" >
                                <div v-if="(currentTournamet.points.length > 0)" class="col col-md-4" v-bind:class="(index > 2) ? 'mt-3' : ''" :key="point.no" >
                                    <template v-if="editPointIndex === index" >
                                        <div class="d-flex align-items-center mb-2" >
                                            <div class="me-2" ><h5>Punkt przesyłania wyników</h5></div>
                                            <input type="text" v-model.number="currentTournamet.points[index].no" class="form-control w60p" :id="'pointNo' + index + _uid"  >
                                            <button type="button" class="btn btn-success ms-2 text-white" v-on:click="onEditPointNoClick(index)" >
                                                <svg width="1.5em" height="1.5em" >
                                                    <use :xlink:href="'#saveItem' + _uid"></use>
                                                </svg>
                                            </button>
                                            <button type="button" class="btn btn-secondary ms-2 text-white" v-on:click="currentTournamet.points[index].no = editPointNo; editPointIndex = -1;" >
                                                <svg width="1.5em" height="1.5em" >
                                                    <use :xlink:href="'#cancelEditItem' + _uid"></use>
                                                </svg>
                                            </button>                                            
                                        </div>
                                    </template>
                                    <template v-else >
                                        <div class="d-flex align-items-center mb-2" >
                                            <div class="me-2" ><h5 class="m-0" >Punkt przesyłania wyników {{ point.no }}</h5></div>
                                            <button :disabled="((currentTournamet.points[index].no === 0) || (editPointIndex > -1))" type="button" class="btn btn-success text-white" v-on:click="editPointNo = currentTournamet.points[index].no; editPointIndex = index;" >
                                                <svg width="1.5em" height="1.5em" >
                                                    <use :xlink:href="'#editItem' + _uid"></use>
                                                </svg>
                                            </button>
                                        </div>
                                    </template>
                                    
                                    <draggable class="list-group players-list" :list="currentTournamet.points[index].players" group="players"  >
                                        <div class="list-group-item" v-for="player in currentTournamet.points[index].players" :key="player.id" >
                                        {{ player.name }} [{{ player.shortname }}]
                                        </div>
                                    </draggable>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="col col-md-3" >
                        <h5>Zawodnicy</h5>
                        <draggable class="list-group players-list" :list="availablePlayersList" group="players" >
                            <div class="list-group-item" v-for="player in availablePlayersList" :key="player.id" >
                            {{ player.name }} [{{ player.shortname }}]
                            </div>
                        </draggable>
                    </div>
                </div>
            </div>
            <div slot="page4" >
                <h4>Krok 4</h4>
                <p>Numery torów w finale</p>
                <hr>
                <div class="row" >
                    <div class="col col-md-9" >
                        <div class="row" >
                            <div class="col" >
                                <div>Ilość torów w eliminatorze:</div>

                                <select v-model.number="currentTournamet.lanesNoCount" :id="'selectLanesNoCount' + _uid" v-on:change="onSelectLanesNoCountChange" class="form-select mb-2 w60p" >
                                    <option value="4" >4</option>
                                    <option value="3" >3</option>
                                </select>
                                
                                <div>Tory w finale:</div>
                                <div v-for="laneNo, index in currentTournamet.lanesNo" :key="index" class="mb-2" >
                                    <div class="d-inline-flex align-items-center" >{{ index + 1 }} Tor od lewej <input type="text" v-model.number="currentTournamet.lanesNo[index]" class="ms-2 form-control w60p" :id="'finalLane' + index + _uid"  ></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>               
            </div>              
            <div slot="page5" >
                <h4>Krok 5</h4>
                <p>Podsumowanie</p>
                <hr>
                <div class="row" >
                    <div class="col" >

                        <div v-show="currentEditMode === 0" >Pomyślnie utworzono turniej o nazwie: <b>{{ currentTournamet.name }}</b></div>
                        <div v-show="currentEditMode === 1" >Pomyślnie zmodyfikowano turniej o nazwie: <b>{{ currentTournamet.name }}</b></div>
                        <div class="mt-3" >Data: <b>{{ new Date().toLocaleDateString("pl-PL") }}</b></div>
                        <div>Ilość zawodników: <b>{{ playersCount }}</b></div>
                        <div>Ilość punktów przesyłania wyników: <b>{{ currentTournamet.numberPointsSendingResults }}</b></div>
                        <div>Numery torów w finale: <b>{{ strLanesNo }}</b></div>
                    </div>
                </div>
            </div>
        </vue-good-wizard>
        <div v-show="showError" class="row" >

            <div class="col py-1 px-1 d-flex justify-content-center" >
                <div class="alert alert-danger text-center px-3" role="alert">
                    {{ errorMsg }}
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped>
   .w80p {
        width: 80px;
        max-width: 80px;
   }
   .w60p {
        width: 60px;
        max-width: 60px;
   }   
   .w-25 {
        width: 25%;
   }
   .checbox-confirm {
        width: 3em;
        height: 1.3em;
   }
   .form-switch-fix {
        /* padding: 0; */
        margin-left: 0;
   }
   .players-list {
        min-height: 85px;
        border-color: #ADB5BD;
        border-style: dashed;
        border-width: 2px;
        max-height: 40vh;
        overflow-y: auto;
   }
   .table-list {
        padding-right: calc(var(--bs-gutter-x) * 0.5);
        padding-left: calc(var(--bs-gutter-x) * 0.5);
    }
    .table-list-header {
        border-radius: var(--bs-border-radius) var(--bs-border-radius) 0 0;
    }
    .table-list-header > .table-item:first-child {
        border-radius: var(--bs-border-radius) 0 0 0;
    }
    .table-list-header > .table-item:last-child {
        border-radius: 0 var(--bs-border-radius) 0 0;
    }
    .table-header-item {
        background-color: #F1F3F5;
    }
    .table-item {
        border: 1px solid #C7C8CA;
        height: 32px;
    }
    .table-item:first-child {
        margin: -1px 0 0 1px;
        /* margin: -1px 0 0 2px; */
        /* max-width: 40px; */
    }
    .table-item:not(:first-child)  {
        margin: -1px 0 0 -1px;
    }
    .table-border-fix {
        border-width: 1px 0 1px 1px;
    }
    .table-scroll-y {
        overflow-y: auto;
        max-height: 400px;
    }
    @media screen and (max-width: 767px) {
        .table-list-header > .table-item:nth-child(2) {
            border-radius: 0 var(--bs-border-radius) 0 0;
        }
    }
    @media screen and ((min-width: 768px) and (max-width: 991px)) {
        .table-list-header > .table-item:nth-child(3) {
            border-radius: 0 var(--bs-border-radius) 0 0;
        }
    }
</style>

<script>

export default {
    name: 'tournament-creator',
    data: function()  {
        return {
            wizardSteps: [
                {
                    label: 'Zbieranie podstawowych informacji',
                    slot: 'page1',
                    options: {
                        //nextDisabled: true, // control whether next is disabled or not
                        nextDisabled: false,
                    },
                },
                {
                    label: 'Zapisy do turnieju',
                    slot: 'page2',
                },                
                {
                    label: 'Przydzielanie zawodników do PPW',
                    slot: 'page3',
                },
                {
                    label: 'Numery torów w finale',
                    slot: 'page4',
                },                
                {
                    label: 'Podsumowanie',
                    slot: 'page5',
                    options: {
                        //nextDisabled: true, // control whether next is disabled or not
                        nextDisabled: false,
                    },
                }
            ],
            currentTournametPlayersList: [],
            availablePlayersList: [],

            emptyPointsSendingResult: {
                id: -1, no: 1, tournamet_id: -1, playersList: [] //id i lista graczy
            },
            currentTournamet: null,
            emptyTournamentDefault: {
                id: -1, //id z bazy albo index tablicy... to się zobaczy
                name: "Turniej", //nazwa
                numberPointsSendingResults: 1, //ilość punktów przesyłania wyników
                roundsCount: 4,//ile rund
                lanesNo: [null, null, null, null],
                lanesNoCount: 4,
                confirmIncomingResults: false, //zatwierdzanie przychodzących wyników
                canceledResultsCount: 0,
                noAcceptedResultsCount: 0,

                //pointsSendingResultsList: [], //lista graczy w turnieju
            },
            currentTournametIndex: -1, //index turnieju nad którym pracujemy
            //currentTournametID: -1, //id turnieju nad którym pracujemy


            currentTournametListSelectAllState: false,


            playersCount: 0,


            currentEditMode: 0, //0 utwórz, 1 edytuj, 2 klonuj, 3 usuń
            stepPage: -1,
            showError: false,
            errorMsg: '',
            showConfirmDeleteModal: false,
            deleteTournametName: '',
            editPointNo: -1,
            editPointIndex: -1,
        };
    },
    props: {
        allPlayersList: {
            type: Array,
            required: true,
        },
        allTournamentsList: {
            type: Array,
            required: true,
        },
    },
    computed: {
        currentTournametID: function() {
            if ((this.currentTournametIndex >= 0) && (this.currentTournametIndex < this.allTournamentsList.length)) {
                return this.allTournamentsList[this.currentTournametIndex].id;
            } else {
                this.currentTournametIndex = -1;
                return -1;
            }
        },
        strLanesNo: function() {
            let result = '';
            for (let i = 0; i < this.currentTournamet.lanesNo.length; i++) {
                if (this.currentTournamet.lanesNo[i] != null) {
                    result += this.currentTournamet.lanesNo[i].toString();
                    if (i < this.currentTournamet.lanesNo.length - 1) {
                        result += ', ';
                    }
                }
            }
            return result;
        },
        selectedCounter: function() {
            let couter = 0;
            if (typeof this.currentTournametPlayersList === 'object') {
                for (let i = 0; i < this.currentTournametPlayersList.length; i++) {
                    if (this.currentTournametPlayersList[i].isPresent) {
                        couter++;
                    }
                }
            }
            return couter;
        }
    },
    methods: {
        getPlayerLastName: function(player) {
            let lastName = '';
            let arrayName = player.name.split(' ');
            if (arrayName.length > 0) {
                lastName = arrayName[0].trim();
            } else {
                arrayName = player.shortname.split(' ');
                if (arrayName.length > 0) {
                    lastName = arrayName[arrayName.length - 1].trim();
                }
            }
            return lastName;
        },
        tournamentPlayersCount: function() {
            let count = 0;
            if (typeof this.currentTournamet.points === 'object') {
                for (let i = 0; i < this.currentTournamet.points.length; i++) {
                    //console.log(typeof this.currentTournamet.points[i].players);
                    if (typeof this.currentTournamet.points[i].players === 'object') {
                        count += this.currentTournamet.points[i].players.length;
                    }
                }
            }
            return count;
        },        
        showErrorMsg: function(error) {
            if (typeof error !== 'undefined') {
                if (Array.isArray(error)) {
                    this.errorMsg = '| ';
                    for (let i = 0; i < error.length; i++) {
                        this.errorMsg = this.errorMsg + error[i] + ' |';
                        if (i < error.length - 1) {
                            this.errorMsg = this.errorMsg + ' ';
                        }
                    }
                } else {
                    this.errorMsg = error;
                }
                this.showError = true;
                setTimeout(() => {
                    this.showError = false;
                    this.errorMsg = '';
                }, 15000);
            }
        },
        onSelectLanesNoCountChange() {
            if (this.currentTournamet.lanesNoCount === 3) {
                if (this.currentTournamet.lanesNo.length > 3) {
                    this.currentTournamet.lanesNo = this.currentTournamet.lanesNo.slice(0, 3);
                }
            } else {
                while (this.currentTournamet.lanesNo.length < 4) {
                    this.currentTournamet.lanesNo.push(null);
                }
            }
        },
        onCurrentTournametListSelectAllChange() {
            if (typeof this.currentTournametPlayersList === 'object') {
                for (let i = 0; i < this.currentTournametPlayersList.length; i++) {
                    if (!this.currentTournametPlayersList[i].disabled) {
                        this.currentTournametPlayersList[i].isPresent = this.currentTournametListSelectAllState;
                    }
                }
            }
        },
        onEditPointNoClick(index) {
            //console.log('onEditPointNo', index);
            let editPoint = this.currentTournamet.points[index];
            this.$parent.$emit('wizard-tournament-update-point-no', JSON.stringify(editPoint), [this.currentTournamet.id], 'edit-tournament-points-no',
                                this.editPointNoTournamentCallback, this.errorCallBack, true);
        },
        onDeleteTournametModalClick() {
            this.$parent.$emit('wizard-tournament-delete', JSON.stringify(this.currentTournamet), [this.currentTournamet.id], 'wizard-tournament-delete',
                                this.deleteTournamentCallback, this.errorCallBack, true);
        },
        onDeleteTournametClick() {
            this.deleteTournametName = this.currentTournamet.name;
            this.showConfirmDeleteModal = true;
        },
        onSelectTournametChange() {
            if ((this.currentTournametIndex >= 0) && (this.currentTournametIndex < this.allTournamentsList.length)) {
                this.currentTournamet = JSON.parse(JSON.stringify(this.allTournamentsList[this.currentTournametIndex]));
            } else {
                this.currentTournamet = JSON.parse(JSON.stringify(this.emptyTournamentDefault));
            }
            this.$refs.wizardTournamentCreator.options[0].nextDisabled = (this.currentEditMode === 3);
            //console.log('onSelectTournametChange');
            //console.log(ev);

        },
        wizardSetPage: function(currentPage) {
            this.stepPage = currentPage;
            this.showError = false;
            this.errorMsg = '';

            //console.log(this.currentTournamet);
            //console.log(this.currentTournamet.lanesNo);
            //console.log(this.currentTournamet.lanesNo.length);
            //return;


            //console.log('pętla');
            for (let i = 0; i < this.currentTournamet.lanesNo.length; i++) {
                //console.log(i);
                if ((this.currentTournamet.lanesNo[i] === '') || (isNaN(parseInt(this.currentTournamet.lanesNo[i])))) {
                    this.currentTournamet.lanesNo[i] = null;
                }
            }
            switch(currentPage) {
                case 0:
                        if (this.currentEditMode === 1) { //edycja
                            this.$parent.$emit('wizard-tournament-update', JSON.stringify(this.currentTournamet), [this.currentTournamet.id], 'wizard-tournament-update',
                            this.updateTournamentCallback, this.errorCallBack, true);

                        } else if (this.currentEditMode === 0) { //tworzenie
                            this.$parent.$emit('wizard-tournament-create', JSON.stringify(this.currentTournamet), [this.currentTournamet.id], 'wizard-tournament-create',
                                this.addTournamentCallback, this.errorCallBack, true);
                        } else if (this.currentEditMode === 3) { //usuwanie
                            return false;
                        }


                        break;
                case 1:
                        //console.log('TERAZ!!!!');

                        //this.currentTournametPlayersList = await this.updatePlayersList(this.currentTournametPlayersList);
    
                        this.updatePlayersList(this.currentTournametPlayersList);

                        //console.log(this.currentTournametPlayersList);
                        //console.log('1');

                        this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.currentTournametPlayersList)));
                        break;
                case 2:
                        this.setPlayersTo0Points(this.availablePlayersList);
                        this.playersCount = this.tournamentPlayersCount();

                        //console.log('2');

        

                        this.$parent.$emit('wizard-save-players', JSON.stringify(this.currentTournamet), [this.currentTournamet.id], 'wizard-save-players',
                            this.savePlayersCallback, this.errorCallBack, true);

                        break;
                case 3:
                        //console.log('3');
                        this.$parent.$emit('wizard-tournament-update', JSON.stringify(this.currentTournamet), [this.currentTournamet.id], 'wizard-tournament-update',
                        this.updateTournamentCallback, this.errorCallBack, true);

                        break;
                case 4:
                        this.stepPage = 0;
                        this.showError = false;
                        this.errorMsg = '';
                        this.currentTournametIndex = -1,
                        this.currentEditMode = 0;
                        this.currentTournamet = JSON.parse(JSON.stringify(this.emptyTournamentDefault));
                        this.$refs.wizardTournamentCreator.goTo(0);
                        return false;
                        break;
                default:
                        break;
            }
            return true;
        },
        nextClicked: function(currentPage) {
                //console.log('next clicked', currentPage)
                return this.wizardSetPage(currentPage);
                //return true; //return false if you want to prevent moving to next page
        },
        backClicked(currentPage) {
            //console.log('back clicked', currentPage);
            //console.log(this.currentTournamet.points[0]);
            if (currentPage === 3) {
                if ((typeof this.currentTournamet.points[0] !== 'undefined') && (this.currentTournamet.points[0] !== null) && (this.currentTournamet.points[0].no === 0) && (Array.isArray(this.currentTournamet.points[0].players))) {
                    this.currentTournamet.points[0].players = [];
                    //this.updatePlayersList(this.currentTournametPlayersList);
                    //this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.currentTournametPlayersList)));
                    //this.playersCount = this.tournamentPlayersCount();
                    this.$parent.$emit('wizard-save-players', JSON.stringify(this.currentTournamet), [this.currentTournamet.id], 'wizard-save-players',
                        this.savePlayersCallback, this.errorCallBack, true);
                }
            }
            if (currentPage === 2) {
                this.setResizeWatcher();
                this.currentTournametPlayersList = this.getParticipatingPlayersList(this.allPlayersList);
                this.currentTournametListSelectAllState = false;
            }
            this.showError = false;
            this.errorMsg = '';
            return true; //return false if you want to prevent moving to previous page
        },
        getParticipatingPlayersList(allPlayersList) {
            let tmpList = [];
            if ((typeof allPlayersList !== 'undefined') && (allPlayersList !== null) && (Array.isArray(allPlayersList))) {
                
                tmpList = JSON.parse(JSON.stringify(allPlayersList));

                for (let j = 0; j < tmpList.length; j++) {
                    tmpList[j].disabled = false;
                    //if (setFalse) {
                    tmpList[j].isPresent = false;
                    //}
                }

                tmpList.sort((a, b) => {
                    let lastNameA = this.getPlayerLastName(a);
                    let lastNameB = this.getPlayerLastName(b);
                    if (lastNameA < lastNameB) {
                        return -1;
                    }
                    if (lastNameA > lastNameB) {
                        return 1;
                    }
                    return 0;
                });

                if ((typeof this.currentTournamet.points !== 'undefined')  && (this.currentTournamet.points !== null) && (Array.isArray(this.currentTournamet.points) && (this.currentTournamet.points.length >= 1)) &&
                    (typeof this.currentTournamet.points[0].players !== 'undefined')  && (this.currentTournamet.points[0].players !== null) && (Array.isArray(this.currentTournamet.points[0].players))) {
                    let elem1 = -1;
                    let elem2 = -1;
                    for (let i = 0; i < tmpList.length; i++) {
                        elem1 = tmpList[i].id;
                        for (let j = 0; j < this.currentTournamet.points.length; j++) {
                            for (let k = 0; k < this.currentTournamet.points[j].players.length; k++) {
                                elem2 = this.currentTournamet.points[j].players[k].id;
                                if (elem1 === elem2) {
                                    tmpList[i].playerData = this.currentTournamet.points[j].players[k].playerData;
                                    //tmpList[i].disabled = true;
                                    tmpList[i].isPresent = true;
                                }
                            }
                        }
                    }
                    /*
                    if ((typeof this.currentTournamet.points[0] !== 'undefined') && (this.currentTournamet.points[0].no === 0) && (this.currentTournamet.points[0] !== null) && (Array.isArray(this.currentTournamet.points[0].players))) {

                        for (let i = 0; i < tmpList.length; i++) {
                            if (!tmpList[i].isPresent) {
                                this.currentTournamet.points[0].players.push({
                                    id: tmpList[i].id,
                                    name: tmpList[i].name,
                                    shortname: tmpList[i].shortname,
                                    hdcp1r: tmpList[i].hdcp1r,
                                    bonus: tmpList[i].bonus,
                                    isPresent: true,
                                    playerData: tmpList[i].playerData
                                });
                                tmpList[i].isPresent = true;

                                console.log(tmpList[i]);
                                //tmpList[i].playerData = null;

                            } 


    
    //currentTournamet.points[index].players
                        }
                    } */
                }


            }
            return tmpList;
        },
        setPlayersTo0Points: function(allPlayersList) {
            //console.log('setPlayersTo0Points');
            //console.log(allPlayersList);
            if ((typeof this.currentTournamet.points !== 'undefined')  && (this.currentTournamet.points !== null) && (Array.isArray(this.currentTournamet.points) && (this.currentTournamet.points.length >= 1)) &&
                (typeof this.currentTournamet.points[0].players !== 'undefined')  && (this.currentTournamet.points[0].players !== null) && (Array.isArray(this.currentTournamet.points[0].players))) {
                //console.log('setPlayersTo0Points 2');
                if ((typeof this.currentTournamet.points[0] !== 'undefined') && (this.currentTournamet.points[0] !== null) && (this.currentTournamet.points[0].no === 0) && (Array.isArray(this.currentTournamet.points[0].players))) {
                    //console.log('setPlayersTo0Points 3');
                    for (let i = 0; i < allPlayersList.length; i++) {
                        //console.log('setPlayersTo0Points 4');
                        let player = null;
                        if (!allPlayersList[i].disabled) {
                            //console.log('setPlayersTo0Points 5');
                            for (let j = 0; j < this.currentTournamet.points.length; j++) {
                                player = this.currentTournamet.points[j].players.find(({ id }) => id === allPlayersList[i].id);
                               //console.log(player);
                                if (typeof player === "object" ) {
                                    //console.log('break');
                                    break;
                                }
                            }

                            //console.log(player);
                            if (typeof player !== "object" ) {
                                this.currentTournamet.points[0].players.push({
                                    id: allPlayersList[i].id,
                                    name: allPlayersList[i].name,
                                    shortname: allPlayersList[i].shortname,
                                    hdcp1r: allPlayersList[i].hdcp1r,
                                    bonus: allPlayersList[i].bonus,
                                    isPresent: true,
                                    playerData: allPlayersList[i].playerData
                                });
                            }
                        }

                      
                    }
                    /* for (let i = 0; i < this.currentTournamet.points[0].players.length; i++) {
                        if (typeof this.currentTournamet.points[0].players[i].points === 'undefined') {
                            this.$set(this.currentTournamet.points[0].players[i], 'points', 0);
                        } else {
                            this.currentTournamet.points[0].players[i].points = 0;
                        }
                    } */
                }
                //for (let i = 0; i < this.currentTournamet.points.length; i++) {

                //}
                    //for (let i = 0; i < this.currentTournamet.points[0].players.length; i++) {
                ///    this.currentTournamet.points[0].players[i].points = 0;
                //}

            }
        },
        updatePlayersList: function(allPlayersList) {

            //console.log('updatePlayersList');
            //console.log(allPlayersList);

            //return allPlayersList;
            if ((typeof this.currentTournamet.points !== 'undefined')  && (this.currentTournamet.points !== null) && (Array.isArray(this.currentTournamet.points) && (this.currentTournamet.points.length >= 1)) &&
                (typeof this.currentTournamet.points[0].players !== 'undefined')  && (this.currentTournamet.points[0].players !== null) && (Array.isArray(this.currentTournamet.points[0].players))) {


                let player = null;

                if ((typeof allPlayersList !== 'undefined') && (allPlayersList !== null) && (Array.isArray(allPlayersList))) {
                    for (let i = 0; i < this.currentTournamet.points.length; i++) {
                        for (let j = this.currentTournamet.points[i].players.length - 1; j >= 0; j--) {
                            
                            player = allPlayersList.find(({ id }) => id === this.currentTournamet.points[i].players[j].id);
                            if (typeof player === "object" ) {
                                if (player.isPresent === false) {
                                    this.currentTournamet.points[i].players.splice(j, 1);
                                    //delete this.currentTournamet.points[i].players[j];
                                }
                            }
                                                
                            //console.log(player);



                        }
                    }
                }

            }
        },
        getAvailablePlayersList2: function(allPlayersList) {
            let tmpList = [];
            if ((typeof allPlayersList !== 'undefined') && (allPlayersList !== null) && (Array.isArray(allPlayersList))) {
                tmpList = JSON.parse(JSON.stringify((allPlayersList)));
                if ((typeof this.currentTournamet.points !== 'undefined')  && (this.currentTournamet.points !== null) && (Array.isArray(this.currentTournamet.points) && (this.currentTournamet.points.length >= 1)) &&
                    (typeof this.currentTournamet.points[0].players !== 'undefined')  && (this.currentTournamet.points[0].players !== null) && (Array.isArray(this.currentTournamet.points[0].players))) {
                    let elem1 = -1;
                    let elem2 = -1;
                    for (let i = tmpList.length - 1; i >= 0; i--) {
                        elem1 = tmpList[i].id;
                        for (let j = 0; j < this.currentTournamet.points.length; j++) {
                            for (let k = 0; k < this.currentTournamet.points[j].players.length; k++) {
                                elem2 = this.currentTournamet.points[j].players[k].id;
                                if (elem1 === elem2) {
                                    tmpList.splice(i, 1);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            return tmpList;
        },
        getAvailablePlayersList: function(currentTournametPlayersList) {

            //let allPlayersList = JSON.parse(JSON.stringify(currentTournametPlayersList));
            let tmpList = [];
            if ((typeof currentTournametPlayersList !== 'undefined') && (currentTournametPlayersList !== null) && (typeof currentTournametPlayersList === 'object')) {
                
                
                for (let i = 0; i < currentTournametPlayersList.length; i++) {
                    if (currentTournametPlayersList[i].isPresent) {
                        tmpList.push(currentTournametPlayersList[i]);
                    } 
                }

                if ((typeof this.currentTournamet.points !== 'undefined')  && (this.currentTournamet.points !== null) && (Array.isArray(this.currentTournamet.points) && (this.currentTournamet.points.length >= 1)) &&
                    (typeof this.currentTournamet.points[0].players !== 'undefined')  && (this.currentTournamet.points[0].players !== null) && (Array.isArray(this.currentTournamet.points[0].players))) {
                    let elem1 = -1;
                    let elem2 = -1;
                    for (let i = tmpList.length - 1; i >= 0; i--) {
                        elem1 = tmpList[i].id;
                        for (let j = 0; j < this.currentTournamet.points.length; j++) {
                            for (let k = 0; k < this.currentTournamet.points[j].players.length; k++) {
                                elem2 = this.currentTournamet.points[j].players[k].id;
                                if (elem1 === elem2) {
                                    tmpList.splice(i, 1);
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            return tmpList;
        },        
        errorCallBack: function(error, action, alwaysFalse) {
            if (this.currentEditMode !== 3) {
                this.$refs.wizardTournamentCreator.goTo(this.stepPage);
            }
            this.$refs.wizardTournamentCreator.options[0].nextDisabled = (this.currentEditMode === 3);
            this.showErrorMsg(error);
            console.log('ERROR in errorCallBack');
            console.log(error);
            console.log(action);
        },
        savePlayersCallback: function(tournament, action) {

            //console.log(tournament);

            if ((typeof tournament !== 'undefined') && (Array.isArray(tournament)) && (tournament.length === 1)) {
                this.currentTournamet.id = tournament[0].id;
                this.currentTournamet.numberPointsSendingResults = tournament[0].numberPointsSendingResults;
                this.currentTournamet.roundsCount = tournament[0].roundsCount;
                this.currentTournamet.confirmIncomingResults = tournament[0].confirmIncomingResults;
                this.currentTournamet.points = [];




                for (let i = 0; i < tournament[0].points.length; i++) {
                    this.currentTournamet.points.push(tournament[0].points[i]);
                }




                /*
                if (Array.isArray(tournament[0].players_data)) {

                    //console.log('ok');

                    for (i = 0; i < tournament[0].players_data.length; i++) {

                        for (let j = 0; j < this.currentTournamet.points.length; j++) {

                            for (let k = 0; k < this.currentTournamet.points[j].players.length; k++) {

                                if (tournament[0].players_data[i].player_id = this.currentTournamet.points[j].players[k].id) {

                                    //console.log('!!!');

                                    this.currentTournamet.points[j].players[k].playerData = tournament[0].players_data;
                                }

                            }

                        }

                    }
                } */

                this.allTournamentsList[this.currentTournametIndex] = JSON.parse(JSON.stringify(this.currentTournamet));
                
                
                this.playersCount = this.tournamentPlayersCount();

                 
                this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.currentTournametPlayersList)));
                //this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.allPlayersList)));
            } else {
                console.log('ERROR in savePlayersCallback');
                console.log(tournament);
                console.log(action);
            }
        },
        editPointNoTournamentCallback: function(tournament, action) {
            //console.log('editPointNoTournamentCallback', tournament, action);
            if ((typeof tournament !== 'undefined') && (Array.isArray(tournament)) && (tournament.length === 1)) {
                this.currentTournamet.points[this.editPointIndex].no = tournament[0].points[this.editPointIndex].no;
                /* this.currentTournamet.points = [];
                for (let i = 0; i < tournament[0].points.length; i++) {
                    this.currentTournamet.points.push(tournament[0].points[i]);
                } */
                this.allTournamentsList[this.currentTournametIndex] = JSON.parse(JSON.stringify(this.currentTournamet)); 
                
               
                //this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.currentTournametPlayersList)));
                //this.currentTournametPlayersList = this.getParticipatingPlayersList(this.allPlayersList);

                

                //this.currentTournametListSelectAllState = false;

                this.editPointNo = -1;
                this.editPointIndex = -1;
            } else {
                console.log('ERROR in editPointNoTournamentCallback');
                console.log(tournament);
                console.log(action);
            }
        },

        updateTournamentCallback: function(tournament, action) {

            this.setResizeWatcher();

            if ((typeof tournament !== 'undefined') && (Array.isArray(tournament)) && (tournament.length === 1)) {
                this.currentTournamet.id = tournament[0].id;
                this.currentTournamet.numberPointsSendingResults = tournament[0].numberPointsSendingResults;
                this.currentTournamet.roundsCount = tournament[0].roundsCount;
                this.currentTournamet.confirmIncomingResults = tournament[0].confirmIncomingResults;
                this.currentTournamet.points = [];
                for (let i = 0; i < tournament[0].points.length; i++) {
                    this.currentTournamet.points.push(tournament[0].points[i]);
                }
                this.allTournamentsList[this.currentTournametIndex] = JSON.parse(JSON.stringify(this.currentTournamet));
                
                /* if (Array.isArray(tournament[0].players_data)) {

                    console.log('ok');

                    for (i = 0; i < tournament[0].players_data.length; i++) {

                        for (let j = 0; j < this.currentTournamet.points.length; j++) {

                            for (let k = 0; k < this.currentTournamet.points[j].players.length; k++) {

                                if (tournament[0].players_data[i].player_id = this.currentTournamet.points[j].players[k].id) {

                                    console.log('!!!');
                                    delete tournament[0].players_data[i].player_id;
                                    delete tournament[0].players_data[i].tournament_id;

                                    this.currentTournamet.points[j].players[k].playerData = tournament[0].players_data[i];
                                }

                            }

                        }

                    }
                } */

                this.currentTournametPlayersList = this.getParticipatingPlayersList(this.allPlayersList);
                this.currentTournametListSelectAllState = false;

                             
                


                
                //this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.allPlayersList)));
            } else {
                console.log('ERROR in updateTournamentCalback');
                console.log(tournament);
                console.log(action);
            }
        },
        deleteTournamentCallback: function(tournament, action) {

            this.setResizeWatcher();

            this.allTournamentsList.splice(this.currentTournametIndex, 1);
            this.currentTournametIndex = this.allTournamentsList.length -1;
            this.currentEditMode = (this.currentTournametIndex >= 0) ? 3 : 0;
            this.$refs.wizardTournamentCreator.options[0].nextDisabled = (this.currentEditMode === 3);

            this.currentTournametPlayersList = this.getParticipatingPlayersList(this.allPlayersList);
            this.currentTournametListSelectAllState = false;

            

            this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.currentTournametPlayersList)));
            //this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.allPlayersList)));
        },
        addTournamentCallback: function(tournament, action) {

            this.setResizeWatcher();

            if ((typeof tournament !== 'undefined') && (Array.isArray(tournament)) && (tournament.length === 1)) {
                this.currentTournamet.id = tournament[0].id;
                this.currentTournamet.numberPointsSendingResults = tournament[0].numberPointsSendingResults;
                this.currentTournamet.roundsCount = tournament[0].roundsCount;
                this.currentTournamet.confirmIncomingResults = tournament[0].confirmIncomingResults;
                this.currentTournamet.points = [];
                for (let i = 0; i < tournament[0].points.length; i++) {
                    this.currentTournamet.points.push(tournament[0].points[i]);
                }
                this.currentTournamet.canceledResultsCount = 0;
                this.currentTournamet.noAcceptedResultsCount = 0;
                this.allTournamentsList.push(JSON.parse(JSON.stringify(this.currentTournamet)));
                this.currentTournametIndex = this.allTournamentsList.length -1;
                this.currentEditMode = 1;

                this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.currentTournametPlayersList)));
                //this.availablePlayersList = JSON.parse(JSON.stringify(this.getAvailablePlayersList(this.allPlayersList)));

                this.currentTournametPlayersList = this.getParticipatingPlayersList(this.allPlayersList);
                this.currentTournametListSelectAllState = false;

                



                /* this.currentTournametPlayersList.sort((a, b) => {
                    let lastNameA = this.getPlayerLastName(a);
                    let lastNameB = this.getPlayerLastName(b);
                    if (lastNameA < lastNameB) {
                        return -1;
                    }
                    if (lastNameA > lastNameB) {
                        return 1;
                    }
                    return 0;
                }); */


            } else {
                console.log('ERROR in addTournamentCallback');
                console.log(tournament);
                console.log(action);
            }
        },
        setResizeWatcher: function() {
            let tableBody = document.getElementById('currentTournametListScroll');
            if ((typeof tableBody !== 'undefined') && (tableBody !== null) && (typeof tableBody === 'object')) {
                new ResizeObserver(this.setSize).observe(tableBody);
            }
        },
        setSize: function() {
            let tableBody = document.getElementById('currentTournametListScroll');
            if ((typeof tableBody !== 'undefined') && (tableBody !== null) && (typeof tableBody === 'object')) {
                let child = tableBody.firstChild;
                if ((typeof child !== 'undefined') && (child !== null) && (typeof child === 'object')) {
                    let tableHeader = document.getElementById('currentTournametListHeader');
                    if ((typeof tableHeader !== 'undefined') && (tableHeader !== null) && (typeof tableHeader === 'object')) {
                        tableHeader.style.width = 'unset';
                        if (tableHeader.clientWidth > child.clientWidth) {
                            tableHeader.style.width  = child.clientWidth.toString() + 'px';
                        }
                    }
                }
            }
        }

    },

    created() {
        this.currentTournamet = JSON.parse(JSON.stringify(this.emptyTournamentDefault));
    },
    mounted() {
        console.log('component tournament-creator mounted')
    }
};
</script>
